// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout__3v4_3"};